import { EPermissoes } from '@/enums/ePermissoes';

export default [
  {
    description: 'Próximas Ações',
    path: '/nao-conformidade/proximas-acoes',
    name: 'proximas-acoes',
    goesToMenu: true,
    component: () => import('@/views/nao-conformidade/proximas-acoes/Index.vue'),
    meta: {
      permissions: [EPermissoes.NaoConformidade_Configuracao],
      escopoObra: 'global'
    }
  }
];

